import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeFaq = () => {
    useEffect(() => {
        const text = document.getElementById("image-text");
        if (text) {
            text.innerHTML = text.innerText
                .split("")
                .map(
                    (char, i) =>
                        `<span class="char" style="transform: rotate(${i * 4.7
                        }deg);">${char}</span>`
                )
                .join("");
        }
    }, []);

    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className="Home_faq_section">
            <div className='container-fluid'>
                <div className='Home_faq_content' data-aos="fade-up" data-aos-duration="2000">
                    <h1>FAQ's</h1>
                    <p className='text-center mt-3'>At Hamo Tech, we understand the importance of clarity when choosing the right educational path. Below are some frequently asked questions to help you better understand our courses, certifications, and student support</p>

                </div>
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-6 d-flex justify-content-center align-items-center">
                        <div className="circle">
                            <div className="logo"></div>
                            <div className="text" id="image-text">
                                <p>Hamo Tech</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" data-aos="zoom-in" data-aos-duration="1500">
                        <div id="accordion">
                            <div class="card home_faq_card">
                                <div class="card-header home_faq_card_header" id="headingOne" data-toggle="collapse" data-target="#collapseOne">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link" aria-expanded="false" aria-controls="collapseOne">
                                            What programs and courses are offered at Hamo Tech?

                                        </button>
                                    </h5>
                                    <div>
                                        <i class="ri-skip-down-fill"></i>
                                    </div>
                                </div>


                                <div id="collapseOne" class="collapse " aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="card-body">
                                        <p>Hamo Tech offers a variety of technical and programming courses such as:
                                            <ul>
                                                <li>Python Programming (Beginner to Advanced)</li>
                                                <li> Java Full Stack Development</li>
                                                <li>JavaScript and Node.js</li>
                                                <li>C++ for Beginners</li>
                                                <li> R Programming for Data Science</li>
                                                <li>Kotlin and Swift for Android and iOS Development</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card home_faq_card">
                                <div class="card-header home_faq_card_header" id="headingTwo" data-toggle="collapse" data-target="#collapseTwo" >
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" aria-expanded="true" aria-controls="collapseTwo">
                                            Are the courses at Hamo Tech beginner-friendly?

                                        </button>
                                    </h5>
                                    <div>
                                        <i class="ri-skip-down-fill"></i>
                                    </div>
                                </div>

                                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                                    <div class="card-body">
                                        Yes, our courses are designed to be accessible for both beginners and professionals. Each program starts with the basics and gradually progresses to advanced concepts to ensure a smooth learning curve.
                                    </div>
                                </div>
                            </div>

                            <div class="card home_faq_card">
                                <div class="card-header home_faq_card_header" id="headingThree" data-toggle="collapse" data-target="#collapseThree">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" aria-expanded="false" aria-controls="collapseThree">
                                            Do you provide certification upon course completion?

                                        </button>
                                    </h5>
                                    <div>
                                        <i class="ri-skip-down-fill"></i>
                                    </div>
                                </div>

                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                    <div class="card-body">
                                        Absolutely! Upon successful completion of any course, students will receive an industry-recognized certificate to validate their skills and knowledge. This certificate can be a great addition to your resume or LinkedIn profile.
                                    </div>
                                </div>
                            </div>



                            <div class="card home_faq_card">
                                <div class="card-header home_faq_card_header" id="headingFour" data-toggle="collapse" data-target="#collapseFour">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" aria-expanded="false" aria-controls="collapseFour">
                                            What are the fees for the courses, and are there any installment options?

                                        </button>
                                    </h5>
                                    <div>
                                        <i class="ri-skip-down-fill"></i>
                                    </div>
                                </div>

                                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                                    <div class="card-body">
                                        Our courses are affordably priced, starting as low as ₹8,000 for beginner courses and going up to ₹25,000 for full-stack development programs. We also offer flexible payment options, including installment plans, to make education accessible to all.
                                    </div>
                                </div>
                            </div>


                            <div class="card home_faq_card">
                                <div class="card-header home_faq_card_header" id="headingFive" data-toggle="collapse" data-target="#collapseFive">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" aria-expanded="false" aria-controls="collapseFive">
                                            Do you offer placement assistance after course completion?

                                        </button>
                                    </h5>
                                    <div>
                                        <i class="ri-skip-down-fill"></i>
                                    </div>
                                </div>

                                <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
                                    <div class="card-body">
                                        Yes, we provide placement assistance to all our students. Our dedicated placement team helps with resume building, interview preparation, and connecting students with top recruiters in the tech industry.
                                    </div>
                                </div>
                            </div>


                            <div class="card home_faq_card">
                                <div class="card-header home_faq_card_header" id="headingSix" data-toggle="collapse" data-target="#collapseSix">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" aria-expanded="false" aria-controls="collapseSix">
                                            Is the learning format online or offline?

                                        </button>
                                    </h5>
                                    <div>
                                        <i class="ri-skip-down-fill"></i>
                                    </div>
                                </div>

                                <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
                                    <div class="card-body">
                                        We offer both online and offline learning options to suit your needs. Students can choose their preferred mode and access high-quality instruction, live sessions, and study materials.
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeFaq;
